import type { LucideIcon } from "lucide-react";

export function GlassIcon({
  icon: Icon,
  className = "",
  size = "md",
}: {
  icon: LucideIcon;
  className?: string;
  size?: "sm" | "md" | "lg";
}) {
  const sizes = {
    sm: { box: "size-9", icon: "size-4" },
    md: { box: "size-12", icon: "size-5" },
    lg: { box: "size-14", icon: "size-6" },
  } as const;
  const s = sizes[size];
  return (
    <div
      className={`relative ${s.box} rounded-2xl overflow-hidden grid place-items-center ${className}`}
      style={{
        background: "linear-gradient(135deg, rgba(255,255,255,0.18), rgba(255,255,255,0.04))",
        border: "1px solid rgba(255,255,255,0.22)",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.30), 0 10px 30px rgba(123,63,242,0.25)",
        backdropFilter: "blur(14px)",
      }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(circle at 30% 25%, rgba(244,114,208,0.55), transparent 60%), radial-gradient(circle at 70% 80%, rgba(123,63,242,0.55), transparent 60%)",
        }}
      />
      <Icon className={`relative ${s.icon} text-white drop-shadow`} />
    </div>
  );
}
